import { useEffect, useState } from 'react';
import { Box } from '@mui/material';

const ScrollProgressBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    let rafId = null;
    let lastScrollTop = 0;

    const updateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      
      // Skip update if scroll position hasn't changed significantly
      if (Math.abs(scrollTop - lastScrollTop) < 1) {
        rafId = null;
        return;
      }
      
      lastScrollTop = scrollTop;
      
      // Prevent division by zero
      const maxScroll = documentHeight - windowHeight;
      if (maxScroll <= 0) {
        setScrollProgress(0);
        rafId = null;
        return;
      }

      const progress = (scrollTop / maxScroll) * 100;
      setScrollProgress(Math.min(100, Math.max(0, progress)));
      rafId = null;
    };

    const handleScroll = () => {
      if (!rafId) {
        rafId = window.requestAnimationFrame(updateScrollProgress);
      }
    };

    // Initial calculation
    updateScrollProgress();

    // Use passive listener for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });

    return () => {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
      }
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: `${scrollProgress}%`,
        height: '3px',
        background: 'linear-gradient(90deg, #a855f7 0%, #ec4899 100%)',
        zIndex: 1200,
        transition: 'width 0.1s ease-out',
        boxShadow: '0 0 10px rgba(168, 85, 247, 0.5)',
        willChange: 'width',
        transform: 'translateZ(0)', // Force GPU acceleration
      }}
    />
  );
};

export default ScrollProgressBar;

